/*
 * Collection card quick-add — small inline variant popup (mirrors the
 * homepage `ai-collection-showcase` quick-add). Replaces Dawn's full-page
 * quick-add modal so choosing a variant happens inside the card.
 */
(function () {
  if (window.__ccQuickAddInit) return;
  window.__ccQuickAddInit = true;

  let activePopup = null;

  function closeActive() {
    if (activePopup) {
      activePopup.classList.remove('active');
      activePopup = null;
    }
  }

  // Refresh the header cart count bubble without a page reload.
  function updateCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((cart) => {
        document.querySelectorAll('.cart-count-bubble').forEach((bubble) => {
          const visible = bubble.querySelector('span[aria-hidden="true"]');
          if (visible) visible.textContent = cart.item_count;
        });
      })
      .catch(() => {});
  }

  // AJAX add-to-cart so the shopper stays on the collection page.
  function addToCart(form) {
    const idInput = form.querySelector('input[name="id"]');
    const addBtn = form.querySelector('.cc-quickadd-add');
    if (!idInput || !idInput.value || (addBtn && addBtn.disabled)) return;

    const original = addBtn ? addBtn.textContent : '';
    if (addBtn) {
      addBtn.disabled = true;
      addBtn.textContent = 'Adding…';
    }

    const drawer = document.querySelector('cart-drawer');
    const sections = drawer ? ['cart-drawer', 'cart-icon-bubble'] : undefined;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: Number(idInput.value),
        quantity: 1,
        sections: sections,
        sections_url: window.location.pathname,
      }),
    })
      .then((res) => res.json().then((data) => ({ ok: res.ok, data })))
      .then(({ ok, data }) => {
        if (!ok) throw new Error(data && data.description ? data.description : 'Error');
        if (addBtn) addBtn.textContent = 'Added ✓';
        closeActive();
        // Open + refresh the native cart drawer if present, else just bump count.
        if (drawer && data.sections) {
          // Cart had ≥1 item after this add; clear the empty-state class that was
          // baked in at page load, otherwise the drawer opens showing the empty
          // layout instead of the new line item.
          drawer.classList.remove('is-empty');
          drawer.renderContents(data);
        } else {
          updateCartCount();
        }
        setTimeout(() => {
          if (addBtn) {
            addBtn.textContent = original;
            addBtn.disabled = false;
          }
        }, 1300);
      })
      .catch(() => {
        // Fall back to a normal submit (redirects to the cart page).
        form.submit();
      });
  }

  function updateSelectedVariant(variants, selector, form) {
    const selected = {};
    selector.querySelectorAll('input[type="radio"]:checked').forEach((r) => {
      selected[r.name] = r.value;
    });

    const variant = variants.find((v) =>
      Object.keys(selected).every((k) => v[k] === selected[k])
    );

    const addBtn = form.querySelector('.cc-quickadd-add');
    let input = form.querySelector('input[name="id"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'id';
      form.insertBefore(input, form.firstChild);
    }

    if (variant) {
      input.value = variant.id;
      if (addBtn) {
        addBtn.disabled = variant.available === false;
        addBtn.textContent = variant.available === false ? 'Sold out' : 'Add to cart';
      }
    }
  }

  function renderVariants(variants, selector, form) {
    if (!variants.length) return;

    const names = [];
    if (variants[0].option1) names.push('option1');
    if (variants[0].option2) names.push('option2');
    if (variants[0].option3) names.push('option3');

    const values = {};
    names.forEach((n) => {
      values[n] = [...new Set(variants.map((v) => v[n]))];
    });

    let html = '';
    names.forEach((name, index) => {
      html += '<div class="cc-quickadd-variant"><div class="cc-quickadd-variant-options">';
      values[name].forEach((value) => {
        const isFirst = value === values[name][0];
        const id = `cc-${name}-${index}-${Math.random().toString(36).slice(2)}`;
        // Price shown per pill only when there's a single option dimension
        // (otherwise price depends on the full combination).
        const match = variants.find((v) => v[name] === value);
        const priceHtml =
          names.length === 1 && match && match.price
            ? `<span class="cc-quickadd-price">${match.price}</span>`
            : '';
        html +=
          `<div class="cc-quickadd-option">` +
          `<input type="radio" name="${name}" value="${value}" id="${id}" class="cc-quickadd-radio" ${isFirst ? 'checked' : ''}>` +
          `<label for="${id}" class="cc-quickadd-button">${value}${priceHtml}</label>` +
          `</div>`;
      });
      html += '</div></div>';
    });

    selector.innerHTML = html;

    selector.querySelectorAll('input[type="radio"]').forEach((radio) => {
      radio.addEventListener('change', () => updateSelectedVariant(variants, selector, form));
    });

    updateSelectedVariant(variants, selector, form);
  }

  function init() {
    document.querySelectorAll('[data-cc-quick-add-trigger]').forEach((trigger) => {
      if (trigger.dataset.ccBound) return;
      trigger.dataset.ccBound = '1';

      // Popup is a sibling of the trigger (works on both collection + homepage)
      const wrap = trigger.parentNode;
      if (!wrap) return;
      const popup = wrap.querySelector('[data-cc-quick-add-popup]');
      if (!popup) return;
      const closeBtn = popup.querySelector('[data-cc-popup-close]');
      const selector = popup.querySelector('[data-cc-variant-selector]');
      const form = popup.querySelector('[data-cc-quick-add-form]');

      let variants = [];
      try {
        variants = JSON.parse(trigger.dataset.productVariants);
      } catch (e) {
        return;
      }

      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (activePopup && activePopup !== popup) closeActive();

        if (popup.classList.contains('active')) {
          popup.classList.remove('active');
          activePopup = null;
        } else {
          renderVariants(variants, selector, form);
          popup.classList.add('active');
          activePopup = popup;
        }
      });

      if (closeBtn) {
        closeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          popup.classList.remove('active');
          activePopup = null;
        });
      }

      if (form) {
        form.addEventListener('submit', (e) => {
          e.preventDefault();
          addToCart(form);
        });
      }
    });
  }

  document.addEventListener('click', (e) => {
    if (
      activePopup &&
      !e.target.closest('[data-cc-quick-add-popup]') &&
      !e.target.closest('[data-cc-quick-add-trigger]')
    ) {
      closeActive();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
